import { Eye, SquareM } from 'lucide-react'

import type { ListViewSwitcherOption } from '@/components/filters/list-view-switcher'
import type { RichTextEditorMode } from '@/components/ui/rich-text-shared'

export const RICH_TEXT_MODE_OPTIONS = [
  { value: 'preview', label: 'Preview', icon: Eye },
  { value: 'markdown', label: 'Markdown', icon: SquareM },
] satisfies ListViewSwitcherOption<RichTextEditorMode>[]
